export default __webpack_public_path__ + "static/media/success-data.5c11251a.jpg";